<template>
<div v-if="isShow">
    <header>通知設定<div class="h-left"><a @click="$emit('close')"><img src="~@/assets/images/icon02.svg"></a></div>
    </header>
    <div id="wrap">
        <div class="search-form-title">プッシュ通知の配信設定</div>
        <div class="porf-area">
            <table>
                <tr>
                    <td>いいね！をもらった時</td>
                    <td class="right">
                        <div class="switch3"><label class="switch3__label"><input type="checkbox" id="enable_push_like" @click="actionNotificationSetting('enable_push_like')" class="switch3__input" /><span class="switch3__content"></span><span class="switch3__circle"></span></label></div>
                    </td>
                </tr>
                <tr>
                    <td>マッチングした時</td>
                    <td class="right">
                        <div class="switch3"><label class="switch3__label"><input type="checkbox" id="enable_push_matching" @click="actionNotificationSetting('enable_push_matching')" class="switch3__input" /><span class="switch3__content"></span><span class="switch3__circle"></span></label></div>
                    </td>
                </tr>
                <tr>
                    <td>メッセージをもらった時</td>
                    <td class="right">
                        <div class="switch3"><label class="switch3__label"><input type="checkbox" id="enable_push_message" @click="actionNotificationSetting('enable_push_message')" class="switch3__input" /><span class="switch3__content"></span><span class="switch3__circle"></span></label></div>
                    </td>
                </tr>
                <tr>
                    <td>足あとがついた時</td>
                    <td class="right">
                        <div class="switch3"><label class="switch3__label"><input type="checkbox" id="enable_push_footprint" @click="actionNotificationSetting('enable_push_footprint')" class="switch3__input" /><span class="switch3__content"></span><span class="switch3__circle"></span></label></div>
                    </td>
                </tr>
                <tr>
                    <td>その他のお知らせ</td>
                    <td class="right">
                        <div class="switch3"><label class="switch3__label"><input type="checkbox" id="enable_push_notice" @click="actionNotificationSetting('enable_push_notice')" class="switch3__input" /><span class="switch3__content"></span><span class="switch3__circle"></span></label></div>
                    </td>
                </tr>
                <tr v-if="parseInt($store.getters.userDetail.sex) === FEMALE">
                    <td>スタンププレゼントされた時</td>
                    <td class="right">
                        <div class="switch3"><label class="switch3__label"><input type="checkbox" id="enable_push_gift" @click="actionNotificationSetting('enable_push_gift')" class="switch3__input" /><span class="switch3__content"></span><span class="switch3__circle"></span></label></div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</div>

<alertDialogBottom :active="isAlert">
    変更しました。
</alertDialogBottom>
<div class="loading-screen" style="opacity: 0.6" v-if="isLoading">
    <div class="loader"></div>
</div>
</template>

<script>
import {
    mapGetters
} from "vuex"
import CONSTANTS from "@/constants"
import alertDialogBottom from "@/views/components/alertDialogBottom.vue";
export default {
    props: {
        isShow: {
            type: Boolean,
            default: false
        },
    },
    emits: ['close'],
    components: {
        alertDialogBottom
    },
    data: () => ({
        isAlert: false,
        isLoading: false,
        FEMALE: CONSTANTS.FEMALE,
    }),

    computed: {
        ...mapGetters(["metadata", 'defaultToken']),
    },
    mounted() {
        this.loadNotificationSetting()
    },
    methods: {
        actionNotificationSetting(element_id) {
            let formData = new FormData();
            formData.append(element_id, (document.getElementById(element_id).checked) ? 1 : 0);
            formData.append('token', this.defaultToken);

            this.$store.dispatch('user/userUpdate', formData).then(data => {
                // TODO: show notice at bottom
                this.isAlert = false
                setTimeout(() => {
                    //Clear all Timeout
                    let id = window.setTimeout(function() {}, 0);
                    while (id--) {
                        window.clearTimeout(id); // will do nothing if no timeout with id is present
                    }

                    // Show bottom alert
                    this.isAlert = true
                    setTimeout(() => {
                        this.isAlert = false
                    }, 1000)
                }, 50)
            }).catch(err => {
                console.log(err.response.data.message);
            });
        },
        loadNotificationSetting() {
            this.isLoading = true
            this.$store.dispatch('user/userIndex', {
                token: this.defaultToken
            }).then(data => {
                this.isLoading = false
                document.getElementById('enable_push_like').checked = parseInt(data.data.enable_push_like)
                document.getElementById('enable_push_matching').checked = parseInt(data.data.enable_push_matching)
                document.getElementById('enable_push_message').checked = parseInt(data.data.enable_push_message)
                document.getElementById('enable_push_footprint').checked = parseInt(data.data.enable_push_footprint)
                document.getElementById('enable_push_notice').checked = parseInt(data.data.enable_push_notice)
                document.getElementById('enable_push_gift').checked = parseInt(data.data.enable_push_gift)

            }).catch(err => {
                this.isLoading = false
                console.log(err)
            })
        },
    }
}
</script>
